export enum AssetType {
    Robot,
    PatientBed,
    Patient,
    Bed,
    Console,
    Trocar,
    Stack,
    Trolley,
    Anesthesia,
    Surgeon,
    Slave,
    AccessPoint,
}

export enum CollisionEnvelopType {
    Sphere,
    OBB,
}

export enum CollisionType {
    NoCollision,
    AllowedCollision,
    Collision,
}

export enum JointType {
    Hinge,
    Pivot,
    BallNSocket,
}

export enum RoomElementType {
    Floor,
    Wall,
    Ceil,
}

export enum IRobotJoints {
    base,
    Link,
    Elbow,
    Wrist,
    effector,
    tip,
}

export enum userIntercationMode {
    dragTargetMode,
    dragTipMode,
}
